import { GET_ORDER_COUNT } from 'actions/types';

const initialState = {
  tasks: { overdue: 1, pending: 1 },
  orders: { pending: 7, returned: 8, cancelled: 1 },
  assetsAssigned: { assignedSum: 2, unassignedSum: null },
};

export function orderCount(state = initialState, action) {
  const { type, payload } = action;
  if (type === `${GET_ORDER_COUNT}_SUCCESS`) {
    return payload;
  }
  return state;
}
